<template>
  <div class="_tab-container">
    <ul class="tabs">
      <li
        v-for="(tab, index) in tabList"
        :key="index"
        @click="handleClick(index, tab)"
        class="tab-item"
        :class="{ 'tab-item-active': active === index }"
      >
        <div class="dot" :class="{ 'dot-active': active === index }"></div>
        {{ tab }}
      </li>
    </ul>
    <div class="tab-tool" v-if="toolIcon">
      <div
        class="image"
        :style="`background-image: url('${toolIcon}')`"
        @click="handleClickTool"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Tabs",
  props: {
    toolIcon: {
      type: String,
      default: ""
    },
    routeName: {
      type: String,
      default: ""
    },
    active: {
      type: Number,
      default: 0
    },
    tabList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  methods: {
    handleClick(index, tab) {
      this.$emit("update:active", index);
      this.$emit("change-tab", tab, index);
    },
    handleClickTool() {
      if (this.routeName === null || this.routeName === "") {
        return this.$emit("tool-click", true);
      }
      this.$router.push({ name: this.routeName });
    }
  }
};
</script>

<style lang="scss" scoped>
._tab-container {
  display: flex;
  .tabs {
    flex: 1;
    overflow-x: scroll;
    overflow-y: hidden;
    height: 35px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: nowrap;
    align-items: baseline;
    flex-direction: row;
    margin: 0;
    padding: 0;
    .tab-item {
      margin-right: 20px;
      height: 30px;
      position: relative;
      font-size: 15px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      white-space: nowrap;
      /*transition: all 0.5s ease 0.1s;*/
      .dot {
        position: absolute;
        right: -5px;
        top: 0;
        border-radius: 50%;
        width: 0;
        height: 0;
        opacity: 0;
        background: rgba(255, 220, 0, 1);
        transition: all 0.5s ease 0s;
      }
      .dot-active {
        opacity: 1;
        width: 14px;
        height: 14px;
      }
    }
    .tab-item-active {
      font-size: 20px;
      font-weight: 600;
    }
  }
  .tab-tool {
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: baseline;
    .image {
      width: 30px;
      height: 30px;
      background-size: 18px 18px;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
}
</style>
